import { SearchCondition } from 'commons/constants/KeyFlowConstants';
import { AscType, SortType } from 'commons/constants/type';
import KeyFlowParamVO from 'commons/vo/param/KeyFlowParamVO';

export type WkblScriptParamVOProps = {
  retr?: number;
  page?: number;
  asc?: AscType;
  sort?: SortType;
  season?: string;
  gameDateFrom?: string;
  gameDateTo?: string;
  scripts?: string[];
  keywords?: string[];
};

class WkblScriptParamVO extends KeyFlowParamVO {
  retr?: number;
  page?: number;
  asc?: AscType;
  sort?: SortType;
  season?: string;
  gameDateFrom?: string;
  gameDateTo?: string;
  scripts?: string[];
  keywords?: string[];

  constructor(data: WkblScriptParamVOProps) {
    super();
    this.season = data.season;
    this.gameDateFrom = data.gameDateFrom;
    this.gameDateTo = data.gameDateTo;
    this.scripts = data.scripts;
    this.keywords = data.keywords;

    this.retr = data.retr || 10;
    this.page = data.page || 0;
    this.sort = data.sort || SearchCondition.Sort.DATE_OF_CREATED;
    this.asc = data.asc || SearchCondition.Asc.DESC;
  }
}

export default WkblScriptParamVO;
